<template>
  <div
    class="d-flex justify-content-between align-items-center border-bottom border-top py-2 px-0"
  >
    <div class="d-flex align-items-center">
      <div class="icon-container mb-auto mt-0">
        <img
          :src="`${useAsset(icon)}`"
          alt="list icon"
          class="my-auto"
          width="24"
          height="24"
        />
      </div>
      <div class="ms-2" style="margin-top: 2px">
        <span class="text-dark item-name" id="name-text">{{ name }}</span>
        <slot></slot>
      </div>
    </div>
    <div class="fw-bold mb-2 item-value">
      <span class="amount-value" >{{ amount }}</span>
      <i class="fa fa-chevron-right mt-3 ms-2"></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import useAsset from "@/apps/credit-line/helpers/useAsset";
defineProps({
  icon: String,
  amount: String,
  name: String,
});
</script>

<style lang="scss" scoped>
.list-item {
  cursor: pointer;
  display: flex;
  flex-direction: row;
}

#name-text {
  color: var(--Surface-Inverse-Surface, #343232);
  font-family: var(--static-body-small-font, Inter);
  font-size: var(--static-body-small-size, 1rem);
  font-style: normal;
  font-weight: 600;
  line-height: var(--static-body-small-line-height, 1.5rem); /* 150% */
  letter-spacing: var(--letter-spacing-narrow, -0.03125rem);
}

.amount-value {
  font-family: var(--static-body-small-font, Inter);
}
</style>
